import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

class LoginForm extends Component
{
	state = {
		email: "",
		password: "",
		submitting: false,
		errors: []
	}

	constructor (props) {
		super(props);
	}

	onSubmit = (e) => {
		e.preventDefault();

		this.setState({ submitting: true });

		const that = this;
		if (this.props.onSubmit) {
			let submitted = this.props.onSubmit(this.state.email, this.state.password);
			if (submitted) {
				submitted.catch(function (errors) {
					that.setState({ errors: errors, submitting: false });
				});
			}
		}
	}

	inputClass (input) {
		if (input in this.state.errors) {
			return "is-danger";
		}

		return "";
	}

	inputState (input) {
		if (input in this.state.errors) {
			return (
				<p className="help is-danger">{this.state.errors[input]}</p>
			);
		}

		return "";
	}

	render () {
		const onSubmit = false;

		return (
			<form onSubmit={this.onSubmit}>
				<div className="field">
					<label className="label">E-Mail Address</label>
					<div className="control has-icons-left">
						<input 
							required 
							type="input" 
							name="email" 
							className="input {this.inputClass('email')}" 
							type="email" 
							placeholder="your@email.com"
							onChange={(e) => { this.setState({ email: e.target.value })}}
						/>
				    <span className="icon is-small is-left">
				    	<FontAwesomeIcon icon="envelope" />
				    </span>
				    {this.inputState('email')}
					</div>
				</div>
				<div className="field">
					<label className="label">Password</label>
					<div className="control has-icons-left">
						<input 
							required 
							type="input" 
							name="password" 
							className="input {this.inputClass('password')}" 
							type="password" 
							placeholder="Password" 
							onChange={(e) => { this.setState({ password: e.target.value })}}
						/>
				    <span className="icon is-small is-left">
				    	<FontAwesomeIcon icon="key" />
				    </span>
				    {this.inputState('password')}
					</div>
				</div>
				<div className="field has-text-centered">
					<input 
						disabled={this.state.submitting} 
						type="submit" 
						className="button is-primary is-gradient" 
						value={!this.state.submitting ? "Login" : "Logging..."}
					/>
					{this.inputState('credentials')}
				</div>
			</form>
		);
	}
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/Components/LoginForm.js